// import React from 'react';
// import createSpeechServicesPonyfill from 'web-speech-cognitive-services';
// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

// const SUBSCRIPTION_KEY = 'e0980562d1f14c68945650dabfa96234';
// const REGION = 'centralindia';

// const { SpeechRecognition: AzureSpeechRecognition } = createSpeechServicesPonyfill({
//   credentials: {
//     region: REGION,
//     subscriptionKey: SUBSCRIPTION_KEY,
//   }
// });
// SpeechRecognition.applyPolyfill(AzureSpeechRecognition);

// const Dictaphone = () => {
//   const {
//     transcript,
//     resetTranscript,
//     browserSupportsSpeechRecognition
//   } = useSpeechRecognition();

//   const startListening = () => SpeechRecognition.startListening({
//     continuous: true,
//     language: 'en-US'
//   });

//   if (!browserSupportsSpeechRecognition) {
//     return null;
//   }

//   return (
//     <div>
//       <button onClick={startListening}>Start</button>
//       <button onClick={SpeechRecognition.abortListening}>Abort</button>
//       <button onClick={resetTranscript}>Reset</button>
//       <p>{transcript}</p>
//     </div>
//   );
// };
// export default Dictaphone;

import * as React from 'react';
import useRecorder from '../utils/useRecorder';
import { Container, Row, Col, Card, Form,Button } from 'react-bootstrap';
import {PaperPlaneTilt,Microphone,Stop ,ArrowCounterClockwise,Repeat} from "phosphor-react";
import axios from "axios";
import { ApiCall } from "../apicall";
function Chatgpt() {
  let [audioURL, isRecording, startRecording, stopRecording,resetRecording] = useRecorder();
 const [fieldS,setFields]=React.useState("newuid");
  const [Text,setText]=React.useState("");
      React.useEffect( () => {
      const fetchText = async () => {
          let fileName = `aud.wav`;
          let fd = new FormData();
         /*let blob = new Blob([recordingUri], { type: "audio/wav" });*/
        const output = await axios({
              method: 'get',
              url: audioURL, // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
              responseType: 'blob'
          });

             let files = new File( [ output.data ], fileName,{type:"audio/wav"} );
             console.log(files);
             fd.append( "file", files );
             let config = {
                 'Content-Type': 'multipart/form-data'
             }
             const textResponse = await ApiCall( "post", "voice-to-text",config, fd );
            if((textResponse && textResponse.data !== '') && textResponse.data !== undefined){
                let config = {
                    'Content-Type': 'application/json'
                }
                let data = {text:textResponse.data,langSelected:"en-IN"}
                const output = await ApiCall( "post", "fetch-query-api",config, data );
                // alert(output.data.answer);
                setText(output.data.answer);
            }else{
                alert("Invalid query!")
            }

      };
      if ( audioURL !== undefined) {
          fetchText();
      }
  }, [ audioURL ] );

  return (
    <>
      <Container>
        <div className="App d-flex justify-content-center mt-4 mb-4">
          {/* <audio src={audioURL} controls /> */}
          <button
            className="startbutton btn btn-success"
            onClick={startRecording}
            disabled={isRecording}>
            <Microphone size={20} />
            start recording
          </button>
          <button
            className="stopbutton btn btn-primary"
            onClick={stopRecording}
            disabled={!isRecording}
            >
            <Stop size={20} />
            stop recording
          </button>
      
          <button className="stopbutton btn btn-danger" onClick={()=>{setText("");resetRecording}}><ArrowCounterClockwise size={20} /> Reset recording</button>
        </div>
      </Container>
      <Container>
        <Row>
          <Col md={12} lg={12} xxl={12}>
            <Card className="leftbox">
              <Card.Body>
                <div className='scrollbars'>
                <h4>
                Click on  start recording and ask your Query to get a comprehensive response
                </h4>
                <p>{Text!=""?Text:null}
                 
                </p>
                {/* <p>
                  This allows quantum computers to perform certain calculations
                  much faster than traditional computers. Additionally, quantum
                  computing can also take advantage of a phenomenon called
                  entanglement, which allows two qubits to be connected in a way
                  that the state of one affects the state of the other, even if
                  they are separated by large distances.
                </p>
                <p>
                  This allows quantum computers to perform certain calculations
                  much faster than traditional computers. Additionally, quantum
                  computing can also take advantage of a phenomenon called
                  entanglement, which allows two qubits to be connected in a way
                  that the state of one affects the state of the other, even if
                  they are separated by large distances.
                </p>                 */}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <div className="testarea">
          <Form>
            <Form.Group className='formgroup'>
              <Form.Label></Form.Label>
              <Form.Control type="text" placeholder="Write Something Here" className='pr-5' />
              <Button variant="default" type="button" className='absoluteBtn '>              
                 <PaperPlaneTilt size={20} color="#f04"/>             
              </Button>
            </Form.Group>
          </Form>
        </div>
      </Container>
      <section className='cardsarea'>
        <Container>  
          <div className='bordertop'> 
          <h3>Suggested prompt</h3>     
          <Row>
            <Col md={3} lg={3} xxl={3} >            
            <Card className="cardTwo">
              <Card.Body>
                <Card.Title>Card Title</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up the bulk of the cards content.
                </Card.Text>
               
              </Card.Body>
            </Card>
            </Col>
            <Col md={3} lg={3} xxl={3}>
            <Card className="cardOne">
              <Card.Body>
                <Card.Title>Card Title</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up the bulk of the cards content.
                </Card.Text>
               
              </Card.Body>
            </Card>
            </Col>
            <Col md={3} lg={3} xxl={3}>
            <Card className="cardThree">
              <Card.Body>
                <Card.Title>Card Title</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up the bulk of the cards content.
                </Card.Text>               
              </Card.Body>
            </Card>
            </Col>
            <Col md={3} lg={3} xxl={3}>
            <Card className="cardFour">
              <Card.Body>
                <Card.Title>Card Title</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up the bulk of the cards content.
                </Card.Text>               
              </Card.Body>
            </Card>
            </Col>
          </Row>
          </div>  
        </Container>
      </section>
    </>
  );
}
export default Chatgpt;